var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu", style: _vm.bgImg },
    [
      _c(
        "el-scrollbar",
        {
          ref: "topScroll",
          staticClass: "nav-list",
          attrs: { noresize: false },
        },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowLeft,
                    expression: "isShowLeft",
                  },
                ],
                staticClass: "left-arrow",
                style: _vm.bgImg,
                on: { click: _vm.handleScrollLeft },
              },
              [_c("i", { staticClass: "iconBtn icon iconjiantou-left" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { ref: "menuList" },
            _vm._l(_vm.menuList, function (item, index) {
              return _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.hidden,
                      expression: "!item.hidden",
                    },
                  ],
                  key: index,
                  staticClass: "nav-item",
                  class: {
                    active:
                      _vm.currentUrlMatched === item.path ||
                      (item.path === "/" && _vm.currentUrlMatched === ""),
                  },
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: item.redirect || item.path } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.generateTitle(
                            item.meta
                              ? item.meta
                              : item.children
                              ? item.children[0].meta
                              : ""
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowRight,
                    expression: "isShowRight",
                  },
                ],
                staticClass: "right-arrow",
                style: _vm.bgImg,
                on: { click: _vm.handleScrollRight },
              },
              [_c("i", { staticClass: "iconBtn icon iconjiantou-right" })]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("search", {
        staticClass: "right-menu-item",
        attrs: { id: "header-search" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }